module.exports = __webpack_public_path__ + "static/media/khaleejdark.7e08c110.png";